<template>
  <sliding-modal :is-open="isOpen" @secondary="$emit('secondary')">
    <form @submit.prevent="onReasonSubmit" class="PASS-BODY">
      <vk-modal-header class="HEADER" selenium="job-details-modal-header">
        Why are you passing?
      </vk-modal-header>
      <vk-modal-content class="d-flex fd-column p-0">
        <div
            v-for="{ reason, text } in $options.PASS_OPTIONS"
            :key="reason"
            class="radio RADIO">
          <input
              type="radio"
              :id="reason"
              name="reason"
              :value="reason"
              v-model="selectedReason"
              :selenium="`job-details-pass-reason-${reason}`"
          />
          <label :for="reason" class="SCALED-RADIO" :selenium="`pass-reason-label-${reason}`">
            {{ text }}
          </label>
        </div>
        <transition name="FADE" mode="out-in">
          <div v-if="isOtherReason" class="TEXTAREA-CONTAINER">
            <textarea
                name="explanation"
                v-model.trim="otherReasonExplanation"
                placeholder="Type your reason..."
                selenium="`job-details-pass-reason-other-textarea`"
                class="input TEXTAREA"
            />
          </div>
        </transition>
      </vk-modal-content>
      <vk-modal-footer class="FOOTER">
        <button
            class="BUTTON-TERTIARY"
            selenium="job-details-modal-cancel-button"
            @click.prevent="$emit('secondary')">
          Cancel
        </button>
        <button
            :disabled="isSubmitDisabled"
            class="BUTTON-PRIMARY"
            selenium="job-details-modal-pass-button">
          Pass
        </button>
      </vk-modal-footer>
    </form>
  </sliding-modal>
</template>

<script>
import { OTHER_PASS_OPTION, PASS_OPTIONS } from '@/constants/pass-options';
import SlidingModal from '@/views/Dashboard/components/SlidingModal';

export default {
  PASS_OPTIONS,
  name: 'pass-modal',
  components: {
    SlidingModal,
  },
  props: {
    isOpen: Boolean,
  },
  data () {
    return {
      selectedReason: '',
      otherReasonExplanation: '',
    };
  },
  computed: {
    isOtherReason () {
      return this.selectedReason === OTHER_PASS_OPTION.reason;
    },
    isSubmitDisabled () {
      return (
        !this.selectedReason
        || (this.selectedReason === OTHER_PASS_OPTION.reason
          && !this.otherReasonExplanation)
      );
    },
  },
  watch: {
    isOpen () {
      if (!this.isOpen) {
        this.selectedReason = '';
        this.otherReasonExplanation = '';
      }
    },
  },
  methods: {
    onReasonSubmit () {
      this.$emit('primary', {
        reason: this.selectedReason,
        explanation: this.otherReasonExplanation,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .PASS-BODY {
    @include responsive(min-width, 100%, $pass-modal-width);
    @include responsive(width, 100%, $pass-modal-width);
    @include responsive(max-width, 100%, $pass-modal-width);
    display: flex;
    flex-direction: column;
  }

  .HEADER {
    @include h6;
    padding: $unit;
    font-weight: 700;
    text-align: center;
    border-bottom: 1px solid $color-gray30;
  }

  .FOOTER {
    @include responsive(justify-content, center, flex-end);
    display: flex;
    padding: 1.5*$unit 3*$unit;
  }

  .RADIO {
    display: flex;
    padding: 1.5*$unit 3*$unit;
    border-bottom: 1px solid $color-gray30;
  }

  .SCALED-RADIO {
    &:before {
      width: 4*$unit;
      height: 4*$unit;
      margin-right: 2*$unit;
    }
  }

  input:checked + label:before,
  input:focus:checked + label:before {
    box-shadow: inset 0px 0px 0px 8px $color-depot;
  }

  .TEXTAREA-CONTAINER {
    display: flex;
    padding: 1.5*$unit 3*$unit;
  }

  .TEXTAREA {
    min-height: 8*$unit;
    height: 8*$unit;
    padding: $unit;
    resize: vertical;

    &::placeholder {
      line-height: 3*$unit;
    }
  }

  .BUTTON-TERTIARY,
  .BUTTON-PRIMARY {
    @include responsive(width, 50%, 17*$unit);
    @include button-small;
    font-weight: 600;
  }

  .BUTTON-TERTIARY {
    @include button-tertiary;
    margin-right: $unit;
  }

  .BUTTON-PRIMARY {
    @include button-primary;
    margin-left: $unit;
  }

  .FADE-enter-active,
  .FADE-leave-active {
    opacity: 1;
    will-change: opacity;
    transition: opacity $transition-half-duration;

    &.FADE-enter,
    &.FADE-leave-to {
      opacity: 0;
    }
  }
</style>
